/*!
 * KoliBri - The accessible HTML-Standard
 */
import { c as createPropDefinition, n as normalizeString } from './normalizers-BNeak4hj.js';

const LOADING_OPTIONS = ['eager', 'lazy'];
const LOADING_SET = new Set(LOADING_OPTIONS);
const loadingProp = createPropDefinition('loading', 'lazy', (value) => normalizeString(value), (v) => LOADING_SET.has(v));

const QUOTE_VARIANT_OPTIONS = ['block', 'inline'];
const QUOTE_VARIANT_SET = new Set(QUOTE_VARIANT_OPTIONS);
const variantQuoteProp = createPropDefinition('variant', 'inline', (value) => normalizeString(value), (v) => QUOTE_VARIANT_SET.has(v));

export { loadingProp as l, variantQuoteProp as v };
//# sourceMappingURL=variant-quote-ClYWonZq.js.map

//# sourceMappingURL=variant-quote-ClYWonZq.js.map